import { render } from "./SubjectForm.vue?vue&type=template&id=5d086f13&scoped=true"
import script from "./SubjectForm.vue?vue&type=script&lang=js"
export * from "./SubjectForm.vue?vue&type=script&lang=js"

import "./SubjectForm.vue?vue&type=style&index=0&id=5d086f13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d086f13"]])

export default __exports__